export default {
  view: 'core.view_activity',
  add: 'core.add_activity',
  change: 'core.change_activity',
  delete: 'core.delete_activity',
  export: 'core.export_activity',
};
